import { useMemo } from 'react';
import { OneWayInServiceDto, OneWayInServiceProviderDto } from 'src/api/v2';
import { Counties } from '../../constants/counties';
import { useClusters } from 'src/features/cluster';
import useGeonorge from '../../hooks/use-geonorge';
import { useTranslation } from 'react-i18next';

const useCounties = (actors: OneWayInServiceProviderDto[]) => {
  const counties = useMemo(() => {
    const countyArray: Array<string> = [];
    return actors
      .reduce((accumulator, provider) => {
        if (!provider.county) return accumulator;
        if (!accumulator.includes(provider.county)) {
          accumulator.push(provider.county);
        }
        return accumulator;
      }, countyArray)
      .map((county) => {
        return {
          label: county,
          value: county,
        };
      });
  }, [actors]);

  return { counties };
};

export const useServiceCounties = (services: OneWayInServiceDto[]) => {
  const { clusters } = useClusters();
  const { getMunicipalityNumberByName } = useGeonorge();
  const { t: tOneWayIn } = useTranslation('oneWayIn');

  const counties = useMemo(() => {
    const countyArray: Array<string> = [];
    services.reduce((accumulator, service) => {
      if (service.municipalities.length > 0) {
        for (const municipality of service.municipalities) {
          const municipalityNumber = isNaN(Number(municipality))
            ? getMunicipalityNumberByName(municipality)
            : municipality;
          const county = Counties.find((county) =>
            county.municipalities.some((municipality) => municipality === municipalityNumber),
          );
          if (county && !accumulator.includes(county.countyName)) {
            accumulator.push(county.countyName);
          }
        }
      } else {
        const county = clusters.find((cluster) => cluster.id === service.clusterId)?.address?.county;
        if (county && !accumulator.includes(county)) {
          accumulator.push(county);
        }
      }
      return accumulator;
    }, countyArray);
    countyArray.sort();
    countyArray.unshift(tOneWayIn('nationWide'));
    return countyArray.map((county) => {
      return {
        label: county,
        value: county,
      };
    });
  }, [services, tOneWayIn, getMunicipalityNumberByName, clusters]);

  return { counties };
};

export default useCounties;
